import React from 'react';
import { MinLoader } from '../loader';
import { Colors, FindLoad, Images } from 'utils';
import { HtmlTooltip } from '../messages';
import { PriceRow } from './tableRows';

export const SelectActions = ({
                                selectedList,
                                selectAll,
                                selectInnetText,
                                submitClaims,
                                removeSelected,
                                actionType,
                                disableSubmit,
                                toolTitle,
                                submitBtnIcon,
                                submitText,
                                renderOtherBtns,
                                allAmount,
                                noSubmit, submitWidth,
                              }) => {
  const loader = FindLoad(actionType);
  return (
    <div>
      <div className="select-action-box">
        <div className="select-count-box">
          <div>
            {selectedList}
          </div>
          <p>selected</p>
        </div>
        <div className="flex-align-center" style={{ gap: 8 }}>
          <button
            className="select-all-btn"
            onClick={(e) => selectAll(e, '', 'selectAll')}>
            <img src={Images.selectAll} alt="icon" />
            <p> {selectInnetText ? selectInnetText : 'Select All'}</p>
          </button>

          {!noSubmit &&
            <>
              {submitBtnIcon ?
                <button className="select-all-btn" onClick={submitClaims}>
                  {loader?.length ?
                    <MinLoader
                      width={'18px'} height={'18px'}
                      margin={'0'} color={'#FFF'} position={'relative'} />
                    :
                    <img src={submitBtnIcon} alt="icon" />
                  }
                  {submitText}
                </button>
                :
                disableSubmit ?
                  <HtmlTooltip title={<p>{toolTitle}</p>} placement="top-start">
                    <button style={{ opacity: 0.5 }} className="submit-btn-box">
                      Submit
                    </button>
                  </HtmlTooltip>
                  :
                  <button className="submit-btn-box" onClick={submitClaims}
                          style={{ width: submitWidth ? submitWidth : 'auto' }}>
                    {loader?.length ?
                      <MinLoader margin={'0'} color={'#FFF'} position={'relative'} />
                      :
                      submitText ? submitText : 'Submit'
                    }
                  </button>
              }
            </>
          }
          {renderOtherBtns}

          {!!allAmount &&
            <div className="select-action-toolbar-amount-wrapper">
              <p>
                Total:
              </p>
              <PriceRow info={allAmount} textWidth={4} />
            </div>
          }
        </div>
        <button className="close-selected-btn" onClick={removeSelected}>
          <img src={Images.closeActions} alt="close" />
        </button>
      </div>
    </div>
  );
};